export default __webpack_public_path__ + "static/media/YAS0150.34I106403_-16867_0.bbf7dbc5.jpg";